




import { Component, Vue } from "vue-property-decorator";

import EntityCrud from "../layouts/components/EntityCrud.vue";
import patientsModel from "../models/user.model";

@Component({
  components: { EntityCrud },
})
export default class Lgpd extends Vue {
  model: any = patientsModel;

  title = "Anomização";
  tableColumns = ["email", "name", "register"];
  filter = { role: "PATIENT" };
  readOnly = true;
  enableExport = false;
  actions = [{ kind: 'FORM', name: 'Anonimizar ', color: 'danger', action: this.anonimizar }]

  //formColumns = ["email", "name", "password", "cpf", "birthDate", "gender", "phoneNumber"];
  formColumns = ["email", "name", "company", "birthDate", "gender", "phoneNumber", "register", "userType"];
  defaultEntity = { role: "PATIENT" };

  async anonimizar(data: any) {
      try {
          await this.model.anonimizar(data);
          this.$vs.notify({ title: "Sucesso", text: "Os dados foram anonimizados.", iconPack: "feather", icon: "icon-check", color: "success" });
          this.$router.back();
      } 
      catch(error) {
          //console.log(error);
          this.$vs.notify({ title: "Erro", text: error.friendlyMessage || "Ocorreu um erro. Tente novamente.", iconPack: "feather", icon: "icon-alert-circle", color: "danger" });
      }
  }
}
